/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { useParams } from "react-router-dom"
import { useRequest } from '../../hooks/UseRequest'
import { useDispatch } from 'react-redux'
import { useForm, Controller } from 'react-hook-form'
import Loading from "../../components/Loading";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
import { setNotification } from "../../redux/notificationSlice";
import { handleErrorResponse } from "../../helpers/errorHandling";

function TestSendEmailDashlet() {
  const requests = useRequest()
  const dispatch = useDispatch();
  const params = useParams()
  const { handleSubmit, control, formState: { errors }, setError } = useForm()
  const [sending, setSending] = useState(false)

  const onSubmit = async (formData) => {
    // Set the saving state to true, indicating the operation is in progress
    setSending(true)
    requests.setEndpoint(`${process.env.REACT_APP_API_DOMAIN}/template/${params.id}/test_send_email`)
    try {
      const response = await requests.post(formData)
      if (response.status === 200 || response.status === 201) {
        dispatch(setNotification({ type: 'success', body: `Emails Send successfully` }))
      } else {
        dispatch(setNotification({ type: 'error', body: `Error: ${response?.message}` }))
      }
      setSending(false)
    } catch (error) {
      setSending(false)
      dispatch(setNotification({ type: 'error', body: `Error: ${error?.response?.data?.message}` }))
    }
  }

  return (
    <div className="message is-white lox-dashlet-detail">
      <div className="message-header has-background-primary has-text-white lox-dashlet-detail__title py-0">
        <p className="is-size-4">Test Send Email</p>
      </div>
      <div className="message-body py-0 px-1" style={{ lineHeight: 1.40 }}>
        <p>
          <i>
            Either the Customer GUID or Lead Funnel Lead ID must be filled out. If the Lead Funnel Lead ID is used, you
            will not be able to use the other LOX related values for Loan/Payment.
          </i>
        </p>
        <form onSubmit={handleSubmit(onSubmit)} id="test_send_email_form">
          <div className="field mt-2">
            <h3 className={`has-text-grey`} htmlFor="email_address">
              Email Address
              <span className="has-text-danger">*</span>
              <span
                style={{ pointerEvents: 'auto' }}
                className={`lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-multiline has-tooltip-bottom has-tooltip-primary has-text-weight-normal`}
                data-tooltip={'Multiple email separate by comma email1@soaren.io,email2@soaren.io'}
              >
                <FontAwesomeIcon
                  icon={faCircleQuestion}
                  className={`pl-1 has-text-link`}
                />
              </span>
            </h3>
            <div className="control">
              <Controller
                name="email_address"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <input {...field} type="text" id="email_address" className="input is-small" />
                )}
              />
              <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                {errors.email_address &&
                  <span>{errors.email_address.message ? errors.email_address.message : "Email Address Invalid!"}</span>}
              </p>
            </div>
          </div>
          <div className="columns">
            <div className="field column is-10-tablet is-6-fullhd is-12-mobile">
              <h3 className={`has-text-grey`} htmlFor="customer_guid">
                Test Customer Guid
                <span className="has-text-danger">*</span>
              </h3>
              <div className="control">
                <Controller
                  name="customer_guid"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input {...field} type="text" id="customer_guid" className="input is-small" />
                  )}
                />
                <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                  {errors.customer_guid &&
                    <span>{errors.customer_guid.message ? errors.customer_guid.message : "Customer Guid Invalid!"}</span>}
                </p>
              </div>
            </div>
          </div>
          <div className="columns">
            <div className="field column is-10-tablet is-6-fullhd is-12-mobile">
              <h3 className={`has-text-grey`} htmlFor="ext_lead_funnel_lead_id">
                Test Lead Funnel Lead ID
                <span className="has-text-danger">*</span>
              </h3>
              <div className="control">
                <Controller
                  name="ext_lead_funnel_lead_id"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input {...field} type="text" id="ext_lead_funnel_lead_id" className="input is-small" />
                  )}
                />
                <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                  {errors.ext_lead_funnel_lead_id &&
                    <span>{errors.ext_lead_funnel_lead_id.message ? errors.ext_lead_funnel_lead_id.message : "LF Lead ID Invalid!"}</span>}
                </p>
              </div>
            </div>
          </div>
          <div className="columns">
            <div className="field column is-10-tablet is-6-fullhd is-12-mobile">
              <h3 className={`has-text-grey`} htmlFor="loan_guid">
                Test Loan Guid
              </h3>
              <div className="control">
                <Controller
                  name="loan_guid"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input {...field} type="text" id="loan_guid" className="input is-small" />
                  )}
                />
                <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                  {errors.loan_guid &&
                    <span>{errors.loan_guid.message ? errors.loan_guid.message : "Loan Guid Invalid!"}</span>}
                </p>
              </div>
            </div>
          </div>
          <div className="columns">
            <div className="field column is-10-tablet is-6-fullhd is-12-mobile">
              <h3 className={`has-text-grey`} htmlFor="payment_guid">
                Test Payment Guid
              </h3>
              <div className="control">
                <Controller
                  name="payment_guid"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input {...field} type="text" id="payment_guid" className="input is-small" />
                  )}
                />
                <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                  {errors.payment_guid &&
                    <span>{errors.payment_guid.message ? errors.payment_guid.message : "Payment Guid Invalid!"}</span>}
                </p>
              </div>
            </div>
          </div>
          <div className="columns">
            <div className="field column is-10-tablet is-6-fullhd is-12-mobile">
              <h3 className={`has-text-grey`} htmlFor="reward_id">
                Test Customer Reward ID
              </h3>
              <div className="control">
                <Controller
                  name="reward_id"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input {...field} type="text" id="reward_id" className="input is-small" />
                  )}
                />
                <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                  {errors.reward_id &&
                    <span>{errors.reward_id.message ? errors.reward_id.message : "Reward ID Invalid!"}</span>}
                </p>
              </div>
            </div>
          </div>
          <div className="columns is-desktop">
            <div className="field column is-8-fullhd">
              <h3 className={`has-text-grey`}>NOTE: Email will be sent immediately</h3>
            </div>
            <div className="field column has-text-right">
              <button
                type="submit"
                className="button is-link has-text-white is-small header-button pl-2 pr-2"
                disabled={sending && 'disabled'}
              >
                {sending ? (
                  <>
                    Sending
                    <Loading size="is-size-6" />
                  </>
                ) : 'Send Email'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default TestSendEmailDashlet
